import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import { connect, Provider } from 'react-redux';
import styled from 'styled-components'
import { ConfigProvider } from 'antd';
import { Responsive, WidthProvider } from "react-grid-layout";

const ResponsiveGridLayout = WidthProvider(Responsive);

const COLUMN_COUNT = 12;
const ROW_HEIGHT_PX = 30;

function transformWidgetsToLayout(widgets) {
  const sorted = [...widgets].sort((a, b) => (a.position || 0) - (b.position || 0));
  const layout = [];

  const defaultMinHeightPx = 200;
  const minHRows = Math.ceil(defaultMinHeightPx / ROW_HEIGHT_PX);

  let currentX = 0;
  let currentY = 0;
  let rowMaxHeight = 0;

  for (const w of sorted) {
    const wCol = Math.round((w.width / 100) * COLUMN_COUNT);
    const hRow = Math.ceil(w.height / ROW_HEIGHT_PX);
    // enforce min height of 300px unless widget is smaller
    const minH = Math.min(hRow, minHRows);
    
    if (currentX + wCol > COLUMN_COUNT) {
      currentX = 0;
      currentY += rowMaxHeight;
      rowMaxHeight = 0;
    }

    layout.push({
      i: w.id,
      x: currentX,
      y: currentY,
      w: wCol,
      h: hRow,
      minH,
      minW: 3,
      static: w.componentName === 'HeaderWidget',
    });

    currentX += wCol;
    rowMaxHeight = Math.max(rowMaxHeight, hRow);
  }

  return layout;
}

const Portal = (props) => {

  const { widgets } = props.portal;

  const layout = transformWidgetsToLayout(widgets);

  const renderWidget = (widget) => {
    let {componentName, id, height, title} = widget;

    const Component = window[componentName].default;

    // return Component && <Component id={id} isAdmin={props.isAdmin} height={height} title={title}/>;
    return Component && <Component id={id} isAdmin={props.isAdmin} title={title}/>;
  };

  return (
    <Provider store={props.store}>
      <ConfigProvider>
        <DashboardContainer>
          <ResponsiveGridLayout
            className="layout"
            layouts={{lg: layout}}
            breakpoints={{ lg: 1000 }}
            cols={{ lg: 12 }}
            isDraggable={true}
            isResizable={true}
            rowHeight={30}
            draggableCancel=".no-drag"
            draggableHandle=".dragHandle"
          >
            {widgets.map((widget) => (
              // <div key={widget.id} style={{ background: '#fff', borderRadius: 8, padding: 12, boxShadow: '0 1px 6px rgba(0,0,0,0.1)' }}>
              <WidgetContainer key={widget.id} name={widget.componentName}>
                {renderWidget(widget)}
              </WidgetContainer>
            ))}
          </ResponsiveGridLayout>
        </DashboardContainer>
      </ConfigProvider>
    </Provider>
  );
}

const WidgetContainer = styled.div`
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  border-radius: 8px;
  /* border: 1px solid #ddd; */
  box-shadow: 4px 4px 25px rgba(0, 0, 0, 0.1);
  box-sizing: border-box;
  /* padding-bottom: ${p => p.name === 'HeaderWidget' ? 0 : '5px'}; */
  position: relative;
  display: flex;
  /* flex-direction: column;
  justify-content: center;
  align-items: center; */
`

const DashboardContainer = styled.div`
  height: calc(100vh - 50px);
  overflow-y: auto;
  /* height: calc(100vh - 50px);
  padding: 24px 12px;
  overflow-y: auto;
  background-color: #efefef;
  .ant-table-container table > thead > tr th {
    background-color: #fff;
  } */
`
const DashboardRow = styled.div`
  /* display: grid; */
  /* margin-left: -12px;
  margin-right: -12px; */
  /* position: relative; */
  box-sizing: border-box;
`
const DashboardWidget = styled.div`
  /* float: left; */
  /* padding-left: 12px;
  padding-right: 12px; */
  
  box-sizing: border-box;
  width: ${ (p) => p.width }%;
  @media (max-width: 1000px) {
    width: 100%;
  }
`

const mapStateToProps = state => {
  const { portal } = state; 
  const { isAdmin } = state.user;

  return { isAdmin, portal };
};

export default connect(mapStateToProps)(Portal);